/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Constants for Settings Profile component
 *
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.26.0
 * @since 1.3.0
 */

export enum ESettingsProfileComponents {
    CONTACTS = 'contacts',
    PREFERRED_LK = 'preferredLK',
    HINTS = 'hints',
    ONBOARDING = 'onboarding',
    PASSWORD = 'password',
    QUESTION = 'question',
}

export enum ESettingsProfileValidationCodes {
    ANSWER_EMPTY = 'profile.answer.empty',
    ANSWER_MIN_LENGTH = 'profile.answer.min.length',
    PASSWORDS_NOT_EQUALS = 'profile.not.equals.passwords',
    PASSWORD_REQUIRED_DIGIT = 'profile.password.required.digit',
    PASSWORD_REQUIRED_LETTER = 'profile.password.required.letter',
    PASSWORD_NEW_REQUIRED = 'profile.password.new.required',
    PASSWORD_CURRENT_REQUIRED = 'profile.password.current.required',
    PASSWORD_ILLEGAL_LETTERS = 'profile.password.illegal.letters',
    PASSWORD_ILLEGAL_LENGTH = 'profile.password.illegal.length',
    PHONE_INCORRECT = 'phone.number.incorrect',
    EMAIL_INCORRECT = 'email.incorrect',
}

export enum ESettingsProfilePasswordFields {
    CURRENT = 'passwordCurrent',
    NEW = 'passwordNew',
    REPEAT = 'passwordNewRepeat',
}

export enum ESettingsProfilePreferredLK {
    B2B = 'B2B',
    SOHO = 'SOHO',
}

export enum ESettingsProfilePasswordError {
    CURRENT = 'passwordCurrentErrorCode',
    NEW = 'passwordNewErrorCode',
    REPEAT = 'passwordNewRepeatErrorCode',
}

export const mapSettingsProfilePasswordFieldsToErrors: { [key: string]: ESettingsProfilePasswordError } = {
    [ESettingsProfilePasswordFields.CURRENT]: ESettingsProfilePasswordError.CURRENT,
    [ESettingsProfilePasswordFields.NEW]: ESettingsProfilePasswordError.NEW,
    [ESettingsProfilePasswordFields.REPEAT]: ESettingsProfilePasswordError.REPEAT,
};

/*
 * -------------------------------------------
 *           ACTIONS
 * -------------------------------------------
 */

export const SETTINGS_PROFILE_INIT_ACTION = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_INIT_ACTION';

export const SETTINGS_PROFILE_LOAD_META_ACTION = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_LOAD_META_ACTION';
export const SETTINGS_PROFILE_LOAD_META_SUCCESS = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_LOAD_META_SUCCESS';
export const SETTINGS_PROFILE_LOAD_META_FAILURE = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_LOAD_META_FAILURE';

export const SETTINGS_PROFILE_SET_IS_COMMON_PARAMS_UPDATED_ACTION =
    '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SET_IS_COMMON_PARAMS_UPDATED_ACTION';

export const SETTINGS_PROFILE_SET_IS_COMMON_PARAMS_VALID_ACTION =
    '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SET_IS_PARAMS_VALID_ACTION';

export const SETTINGS_PROFILE_SET_IS_PREFERRED_LK_PARAMS_UPDATED_ACTION =
    '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SET_IS_PREFERRED_LK_PARAMS_UPDATED_ACTION';

export const SETTINGS_PROFILE_RESET_PARAMS_ACTION = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_RESET_PARAMS_ACTION';

export const SETTINGS_PROFILE_SET_PARAM_CONTACTS_ACTION =
    '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SET_PARAM_CONTACTS_ACTION';
export const SETTINGS_PROFILE_SET_PARAM_COMPONENTS_ACTION =
    '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SET_PARAM_COMPONENTS_ACTION';
export const SETTINGS_PROFILE_SET_PARAM_PREFERRED_LK_ACTION =
    '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SET_PARAM_PROFILE_LK_ACTION';
export const SETTINGS_PROFILE_SET_PARAM_PASSWORD_ACTION =
    '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SET_PARAM_PASSWORD_ACTION';
export const SETTINGS_PROFILE_SET_PARAM_QUESTION_ACTION =
    '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SET_PARAM_AUTH_ACTION';

export const SETTINGS_PROFILE_SAVE_COMMON_ACTION = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SAVE_COMMON_ACTION';
export const SETTINGS_PROFILE_SAVE_COMMON_SUCCESS = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SAVE_COMMON_SUCCESS';
export const SETTINGS_PROFILE_SAVE_COMMON_FAILURE = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SAVE_COMMON_FAILURE';

export const SETTINGS_PROFILE_SAVE_PASSWORD_ACTION = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SAVE_PASSWORD_ACTION';
export const SETTINGS_PROFILE_SAVE_PASSWORD_SUCCESS = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SAVE_PASSWORD_SUCCESS';
export const SETTINGS_PROFILE_SAVE_PASSWORD_FAILURE = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SAVE_PASSWORD_FAILURE';

export const SETTINGS_PROFILE_SAVE_QUESTION_ACTION = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SAVE_QUESTION_ACTION';
export const SETTINGS_PROFILE_SAVE_QUESTION_SUCCESS = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SAVE_QUESTION_SUCCESS';
export const SETTINGS_PROFILE_SAVE_QUESTION_FAILURE = '@@b2b_portal_ui/profile/SETTINGS_PROFILE_SAVE_QUESTION_FAILURE';
